document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".header-wrapper");
  if (!header) return;

  const initialMarginTop = parseFloat(getComputedStyle(header).marginTop);

  window.addEventListener("scroll", () => {
    const scrollY = window.scrollY;
   // console.log(scrollY)

    const newMarginTop = Math.max(initialMarginTop - scrollY, 0);

    header.style.marginTop = newMarginTop + "px";
  });
});